import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const BASE_METRICS_API_REDUCER_KEY = "baseMetricsApi";

export const baseMetricsApi = createApi({
  reducerPath: BASE_METRICS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["base-metric"],
  endpoints: (builder) => ({
    getBaseMetricsList: builder.query({
      query: ({ page, limit }) => {
        return {
          url: `emissions/base-matrics/?page=${page}&limit=${limit || 100}`,
        };
      },
      providesTags: ["base-metric"],
    }),

    getBaseMetric: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `emissions/base-matrics/${id}/`,
        };
      },
      providesTags: ["base-metric"],
    }),

    createBaseMetric: builder.mutation({
      query: (body) => ({
        url: `emissions/base-matrics/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["base-metric"],
    }),

    updateBaseMetric: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `emissions/base-matrics/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["base-metric"],
    }),

    deleteBaseMetric: builder.mutation({
      query: (id) => ({
        url: `emissions/base-matrics/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["base-metric"],
    }),

    getMetricItemsList: builder.query({
      query: ({ page, limit, nodeId }) => {
        return {
          url: `emissions/base-matric-items/?page=${page}&organization_taxonomy=${nodeId}&limit=${
            limit || 50
          }`,
        };
      },
      providesTags: ["base-metric"],
    }),

    getMetricItem: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `emissions/base-matric-items/${id}/`,
        };
      },
      providesTags: ["base-metric"],
    }),
    updateMetricItem: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `emissions/base-matric-items/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["base-metric"],
    }),
    deleteMetricItem: builder.mutation({
      query: (id) => ({
        url: `emissions/base-matric-items/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["base-metric"],
    }),
    deletemultipleMetricItem: builder.mutation({
      query: (ids) => ({
        url: `/emissions/base-matric-item/`,
        method: "DELETE",
        body: JSON.stringify({ ids }), // Correctly format the request body
        headers: { "Content-Type": "application/json" }, // Ensure correct content type
      }),
      invalidatesTags: ["base-metric"],
    }),

    upsertMetricItems: builder.mutation({
      query: (body) => {
        return {
          url: `emissions/base-matric-items-upsert/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["base-metric"],
    }),
  }),
});

export const {
  useGetBaseMetricsListQuery,
  useCreateBaseMetricMutation,
  useGetBaseMetricQuery,
  useUpdateBaseMetricMutation,
  useDeleteBaseMetricMutation,

  useGetMetricItemQuery,
  useGetMetricItemsListQuery,
  useUpsertMetricItemsMutation,
  useUpdateMetricItemMutation,
  useDeleteMetricItemMutation,
  useDeletemultipleMetricItemMutation,
} = baseMetricsApi;
